import React, { useCallback, useRef, useContext } from "react";
import ReusableTable from "./ReusableTable";
import { fetchTransactions } from "../util/fetchUserUtil"; // Import the fetchSubscribers function
// import { ConfigContext } from "../util/ConfigContext";
// import getJwtData from "../util/JwtUtil";

export const TransactionsTable = () => {
  //   const { jwt } = useContext(ConfigContext);
  //   let jwtData = getJwtData(jwt);
  // const dialogRef = useRef();

  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchTransactions(postData);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"transactions_table"}
        tableType={"transactions"}
        tableName={"Transactions"}
        needGlobalFilter={true}
        needColumnFilter={true}
        needPagination={true}
        onStateChange={fetchData}
      />
    </div>
  );
};

export default TransactionsTable;
